import { useState } from "react";
import styled from "styled-components";

import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import { useToast } from "../../../contexts/ToastContext";
import useApi from "../../../hooks/useApi";

const Titulo = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #263b4b;
    text-align: center;
`;

const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
`;

const Resumo = styled.div`
    margin: 15px 0 0 0;
    padding: 12px;
    background-color: #f5f7fa;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    font-size: 13px;
    color: #111;
    text-align: center;
`;

const BotoesWrapper = styled.div`
    margin-top: 25px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const Botao = styled.button`
    padding: 9px 12px;
    background-color: ${(p) => (p.$cancel ? "#e5e7eb" : "#e11d48")};
    color: ${(p) => (p.$cancel ? "#333" : "white")};
    border: none;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

const ModalDeleteItem = ({ item, fecharModal, onDeleted }) => {
    const api = useApi();
    const { notifyError, notifySuccess } = useToast();
    const [removendo, setRemovendo] = useState(false);

    const handleDelete = async () => {
        if (!item?.id) return;

        setRemovendo(true);

        try {
            const { data } = await api.post(
                "/Painel/API/Prossmap/Itens/Delete/index.php",
                { id: item.id }
            );

            if (data?.success) {
                notifySuccess(data?.message || "Item removido com sucesso.");
                if (onDeleted) await onDeleted();
                fecharModal();
                return;
            }

            notifyError(data?.message || "Não foi possível remover o item.");
        } catch (err) {
            console.error(err);
            const msg = err?.response?.data?.message || "Erro ao remover item.";
            notifyError(msg);
        } finally {
            setRemovendo(false);
        }
    };

    return (
        <Overlay state>
            <Modal size="sm">
                <Titulo>Confirmar exclusão</Titulo>
                <Subtitulo>Tem certeza que deseja remover este item?</Subtitulo>
                {item && (
                    <Resumo>
                        <strong>{item.descricao}</strong>
                    </Resumo>
                )}
                <BotoesWrapper>
                    <Botao type="button" $cancel onClick={fecharModal} disabled={removendo}>
                        CANCELAR
                    </Botao>
                    <Botao type="button" onClick={handleDelete} disabled={removendo}>
                        {removendo ? "REMOVENDO…" : "REMOVER"}
                    </Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );
};

export default ModalDeleteItem;
